import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { ContentComponent } from '../components/content/content';
import { NavbarComponent } from '../components/navbar/navbar';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { MenuComponent } from '../components/menu/menu';
import { CoreSidebarComponent } from '../../../@core/components/core-sidebar/core-sidebar';
import { FooterComponent } from '../components/footer/footer';

@Component({
    selector: 'horizontal-layout',
    templateUrl: './horizontal-layout.html',
    styleUrl: './horizontal-layout.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [NgTemplateOutlet, ContentComponent, NavbarComponent, NgClass, DefaultClassDirective, MenuComponent, CoreSidebarComponent, FooterComponent]
})
export class HorizontalLayoutComponent implements OnInit, OnDestroy {
  private _coreConfigService = inject(CoreConfigService);

  coreConfig: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }
}
